import { render, staticRenderFns } from "./PnrStudentDetails.vue?vue&type=template&id=ba4452f2&"
import script from "./PnrStudentDetails.vue?vue&type=script&lang=js&"
export * from "./PnrStudentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports